import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useConfigStore } from "~/store/config"

export const useUserStore = defineStore('user', () => {
  const isLoggedInUser = ref(false)
  const userType = ref<string | null>(null)

  const refreshUser = async () => {
    const config = useConfigStore().config

    if (!config.AUTH_STATUS_URL) {
      console.warn('[AuthStatus] AUTH_STATUS_URL not configured')
      return
    }

    try {
      const response = await fetch(config.AUTH_STATUS_URL, {
        method: 'GET',
        credentials: 'include',
        headers: { 'Accept': 'application/json' },
      })

      if (response.ok) {
        const data = await response.json()
        isLoggedInUser.value = data.authenticated
        userType.value = data.user_type
      }
    } catch (error) {
      console.warn('[AuthStatus] API check failed:', error)
    }
  }

  setInterval(refreshUser, 1000 * 15)

  return { isLoggedInUser, userType, refreshUser }
})
